<template>
    <remarketings-store
        :store-on-created="!!$route.query.welcome"
        :store-on-created-data="{
            campaign: 'landlord-rent-collection'
        }"
    >
        <modal-blue
            :is-open="!!$route.query.welcome"
            @close="closeModal"
        >
            <div
                slot-scope="{ close }"
                class="text-grey-darker"
            >
                <div class="px-4 py-6 border-b sm:px-6">
                    <h1 class="mb-3 text-lg font-normal text-grey-darkest">
                        Welcome to Rentora!
                    </h1>

                    <p class="mb-3">
                        Collecting rent through Rentora is easy to do, and only takes a few minutes to set-up.
                    </p>

                    <p class="mb-3">
                        You just need need to create a tenancy and invite your tenant(s).
                    </p>

                    <p class="mb-3">
                        For more information on the process, and a thorough guide on doing so, please refer
                        to the following guides:
                    </p>

                    <p>
                        <a
                            href="https://help.rentora.co.uk/article/42-how-do-i-create-a-tenancy"
                            class="inline-flex items-center text-blue"
                            target="_blank"
                            rel="noopener"
                        >
                            How do create a tenancy?

                            <base-svg
                                name="icon-external-window"
                                class="w-4 h-4 ml-1 fill-primary-blue fill-secondary-blue"
                            />
                        </a>

                        <a
                            href="https://help.rentora.co.uk/article/54-how-do-i-invite-a-tenant"
                            class="inline-flex items-center text-blue"
                            target="_blank"
                            rel="noopener"
                        >
                            How do I invite a tenant?

                            <base-svg
                                name="icon-external-window"
                                class="w-4 h-4 ml-1 fill-primary-blue fill-secondary-blue"
                            />
                        </a>
                    </p>
                </div>

                <div class="px-4 py-3 text-right rounded-b bg-grey-bg sm:px-6">
                    <button
                        type="button"
                        class="flex-none w-full btn btn-blue md:w-auto"
                        @click.prevent="close"
                    >
                        Get Started
                    </button>
                </div>
            </div>
        </modal-blue>
    </remarketings-store>
</template>

<script>
    import _ from 'lodash'
    import RemarketingsStore from '../../../../../components/remarketings-store'

    export default {
        components: {
            RemarketingsStore
        },
        methods: {
            closeModal () {
                this.$router.replace({
                    query: _.omit(this.$route.query, ['welcome'])
                })
            }
        }
    }
</script>
